import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { EditDialogComponent } from '../../__common/edit-dialog/edit-dialog.component';

interface ChecklistItem {
  checklist_id: string;
  name: string;
  id: string;
  item: string;
  description: string | null;
  completed: boolean;
  dueDate: string;
}

@Component({
  selector: 'app-checklist',
  templateUrl: './checklist.component.html',
  styleUrls: ['./checklist.component.css']
})
export class ChecklistComponent implements OnInit {
  checklists: { name: string, items: ChecklistItem[] }[] = [];

  constructor(private dialog: MatDialog) {}

  ngOnInit(): void {
    this.loadChecklists();
  }

  loadChecklists(): void {
    // Example data structure based on provided object
    const data = [
      {
        "checklist_id": "4",
        "name": "Solicitud Visado en Costa Rica",
        "id": "71",
        "item": "Formulario de solicitud de visado",
        "description": null,
        "completed": true,
        "dueDate": "0000-00-00 00:00:00"
      },
      {
        "checklist_id": "4",
        "name": "Solicitud Visado en Costa Rica",
        "id": "69",
        "item": "Certificado de Antecedentes Penales",
        "description": "Para cuando la duración de los estudios supere los seis meses y solo para mayores de edad...",
        "completed": true,
        "dueDate": "0000-00-00 00:00:00"
      },
      {
        "checklist_id": "73",
        "name": "Día a día en España",
        "id": "253",
        "item": "Cómo utilizar el servicio de bicicletas de tu ciudad",
        "description": null,
        "completed": false,
        "dueDate": "0000-00-00 00:00:00"
      },
      {
        "checklist_id": "73",
        "name": "Día a día en España",
        "id": "254",
        "item": "Supermercados más conocidoos en tu ciudad",
        "description": null,
        "completed": false,
        "dueDate": "0000-00-00 00:00:00"
      }
    ];

    // Process data to structure suitable for component
    const grouped = data.reduce((acc, curr) => {
      const checklist = acc.find(cl => cl.name === curr.name);
      if (checklist) {
        checklist.items.push(curr);
      } else {
        acc.push({ name: curr.name, items: [curr] });
      }
      return acc;
    }, []);

    this.checklists = grouped;
  }

  toggleCompleted(item: ChecklistItem): void {
    // Handle toggling of task completion status
    item.completed = !item.completed;
    // Update the backend or service with the new status
  }

  editTask(task: ChecklistItem): void {
    const dialogRef = this.dialog.open(EditDialogComponent, {
      width: '250px',
      data: { field: 'task', value: task }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        // Update task with new data
        Object.assign(task, result);
      }
    });
  }
}
